import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {StaticQuery, graphql} from 'gatsby'
import styled from '@emotion/styled'
import emailValidator from 'email-validator'
import {ClipLoader} from 'react-spinners'
import {withTheme} from 'emotion-theming'

import {SubmitButton} from './Button'
import Input from './Input'
import {sendForm} from '../utils/forms'


const RootContainer = styled.div`
`

const phoneBreakpoint = '@media only screen and (max-width: 1000px)'


const Title = styled.h1`
	font-size: ${props => props.theme.fontSizes.big30};
	margin-bottom: 1.875rem;
`

const Text = styled.div`
	margin-bottom: 1.875rem;
	font-weight: ${props => props.theme.fontWeights.regular};
`

const NewsletterFormStyled = styled.form`
	margin: 0;
	display: flex;
	max-width: 25.7rem;
	
	& > * {
	}
	
	${phoneBreakpoint}{
		flex-direction: column;
		align-items: stretch;
	}
`
const NewsletterInput = styled(Input)`
`

const SubmitButtonStyled = styled(SubmitButton)`
	margin-left: 1rem;
	align-items: center;
	justify-content: center;
	
	${phoneBreakpoint}{
		margin: 0;
		margin-top: .7rem;
	}
`

SubmitButton.defaultProps = {
	type: 'submit',
}

const ErrorMessage = styled.div`
	font-size: ${props => props.theme.fontSizes.small};
	color: FireBrick;
	margin-bottom: 1rem;
`

const Success = styled.div`
	color: ForestGreen;
	font-size: ${props => props.theme.fontSizes.small};
	margin-bottom: 1rem;
`

const LoadingContainer = styled.div`

`

function NewsletterForm({className, theme}) {
	const [email, setEmail] = useState('')
	const [submitState, setSubmitState] = useState({
		loading: false,
		error: null,
		success: false,
	})

	const onFormSubmit = (e) => {
		e.preventDefault()
		if (submitState.success) return

		if (!emailValidator.validate(email)) {
			setSubmitState({loading: false, error: new Error('Please fill in a valid email'), success: false})
			return
		}

		setSubmitState({loading: true, error: null, success: false})
	}

	useEffect(() => {
		if (!submitState.loading) return

		sendForm({formContent: {email}, formName: 'Newsletter form'})
			.then(() => setSubmitState({loading: false, success: true, error: null}))
			.catch(error => setSubmitState({loading: false, success: false, error}))

	}, [submitState.loading])

	useEffect(() => {
		if (!submitState.success) return
		setTimeout(() => {
			setEmail('')
			setSubmitState({loading: false, error: null, success: false})
		}, 5000)
	}, [submitState.success])

	return <StaticQuery
		query={graphql`
    {
		newsletter: file(relativePath: {eq: "global/newsletter.json"}) {
			childGlobalJson {
				title
				text
				placeholder
				submitText
			}
		}
	}
    `}
		render={(rawData) => {
			const data = rawData.newsletter.childGlobalJson
			return <RootContainer className={className}>
				<Title>{data.title}</Title>
				<Text>{data.text}</Text>
				{!!submitState.error && <ErrorMessage>{submitState.error.message}</ErrorMessage>}
				{!!submitState.success && <Success>You have been subscribed. Thank you.</Success>}
				{!!submitState.loading && <LoadingContainer>
					<ClipLoader color={theme.colors.main}/>
				</LoadingContainer>}
				{(!submitState.loading && !submitState.success) && <NewsletterFormStyled onSubmit={onFormSubmit}>
					<NewsletterInput
						inputProps={{
							value: email,
							onChange: e => setEmail(e.target.value),
							placeholder: data.placeholder,
						}}/>
					<SubmitButtonStyled>{data.submitText}</SubmitButtonStyled>
				</NewsletterFormStyled>}
			</RootContainer>
		}
		}/>
}

NewsletterForm.propTypes = {
	className: PropTypes.string,
}

NewsletterForm.defaultProps = {
	className: '',
}

export default withTheme(NewsletterForm)
